<script>
import { VIcon } from 'vuetify/lib'
import { EAvatar } from '../index'
import themeable from 'vuetify/lib/mixins/themeable'

export default {
  name: 'EInputTag',
  mixins: [themeable],
  props: {
    label: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: false,
    },
    avatar: {
      type: Object,
      default: undefined,
    },
    small: Boolean,
    large: Boolean,
  },
  computed: {
    classes() {
      return {
        'e-input-tag--with-avatar': this.avatar,
        'e-input-tag--closable': this.closable,
        'e-size--small': this.small,
        'e-size--large': this.large,
        ...this.themeClasses,
      }
    },
  },
  methods: {
    genAvatar() {
      const data = {
        props: {
          xSmall: !this.large,
          small: this.large,
          ...(this.avatar || {}),
        },
      }
      return this.$createElement(
        'span',
        {
          staticClass: `e-input-tag__avatar`,
        },
        [this.$createElement(EAvatar, data)]
      )
    },

    genClose() {
      return this.$createElement(
        VIcon,
        {
          staticClass: 'e-input-tag__close',
          props: {
            size: 18,
          },
          on: {
            click: (e) => {
              e.stopPropagation()
              e.preventDefault()
              this.$emit('click:close')
            },
          },
        },
        'icon-close-sign'
      )
    },
    genText() {
      return this.$createElement(
        'span',
        {
          staticClass: 'e-input-tag__text',
        },
        [this.label ? this.label : this.$slots.default]
      )
    },
    genContent() {
      return this.$createElement(
        'span',
        {
          staticClass: 'e-input-tag__content',
        },
        [this.avatar && this.genAvatar(), this.genText(), this.closable && this.genClose()]
      )
    },
  },
  render(h) {
    return h('span', { staticClass: 'e-input-tag', class: this.classes }, [this.genContent()])
  },
}
</script>
